<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.payments_quotas', 2),
                        href: meta.links.index,
                    },
                    {
                        name: schoolYear.year_range,
                        href: null,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.schoolYears" />
        </div>

        <div class="flex justify-end mt-5">
            <AppButton element="inertia-link" :href="meta.links.edit">
                {{ $t('messages.edit') }}
            </AppButton>
        </div>

        <AppWell v-if="selects.length" class="mt-3">
            <div class="md:grid md:grid-cols-3 md:gap-6">
                <CardPanel v-for="select in selects" :key="select.id">
                    <div class="flex justify-between">
                        <div>{{ select.name }}</div>
                        <div>{{ select.total }} / {{ select.quota }}</div>
                    </div>

                    <ProgressBar :percent="select.percent" :color="select.percent >= 100 ? 'green' : 'gray'" />
                </CardPanel>
            </div>
        </AppWell>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.grade_levels', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 2) }}
                                </th>
                                <th
                                    v-for="select in selects"
                                    :key="select.id"
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ select.name }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(gradeLevel, index) in gradeLevels"
                                :key="gradeLevel.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ gradeLevel.name }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ gradeLevel.students_count }}
                                </td>
                                <td
                                    v-for="select in gradeLevel.selects"
                                    :key="select.select_id"
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ select.amount }}
                                    <span v-if="select.expected"> ({{ select.paid }} / {{ select.expected }}) </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import AppWell from '@/Shared/AppWell.vue';
import CardPanel from '@/Shared/CardPanel.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        PanelPage,
        AppButton,
        AppWell,
        CardPanel,
        ProgressBar,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'schoolYear', 'gradeLevels', 'selects'],
    data() {
        return {};
    },
};
</script>
